
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$link.js';

import __default__ from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$link.js';
export default __default__;
